<template>
  <div>
    <div v-if="MiniFestivalsArray.length > 0">
      <div class="" v-for="(festival, festIndex) in MiniFestivalsArray" :key="festIndex">
        <section class=".filter-sticky-top-heading pt-1 ">
          <section class="container-fluid my-1">
            <div class="download-app">
              <div class="row">
                <div class="col-12 pr-0 align-self-center">
                  <div class="d-flex align-slef-center mb-2">
                    <!-- <img :src=" CinemaList[0].OrganizationLogo" height="40" width="40"> -->
                    <div class="">
                      <strong class="text_theme"> {{ festival.category_link_name }}</strong>
                      <!-- <div class="promo-line small">
                        {{ festival.category_link_description }}
                      </div> -->
                    </div>
                    <!-- <img :id="'tooltip_mini' + festIndex" src="@/assets/img/svg/info-rd-icon.svg"
                      class="rounded-circle ml-3" /> -->
                    <!-- <button class="btn btn-danger viewmore-btn mr-4" @click="openModal(festIndex)">Know more</button> -->
                    <b-modal v-model="showModal[festIndex]" hide-backdrop>
                      <ul>
                        <li>
                          {{ festival.category_link_description }}
                        </li>
                      </ul>
                    </b-modal>
                    <!-- ToolTip -->
                    <b-tooltip :target="'tooltip_mini' + festIndex" placement="bottom" triggers="click">

                    </b-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <section class=" ownScreen-color">
          <div class="container-fluid mb-4">
            <div class="OwnScreening" v-if="festival.movie_data.data.length > 0">
              <Slick ref="slick1" :options="movieSlider" class="now-showing">
                <div v-for="(singleMovie, singleindex) in festival.movie_data.data" :key="singleindex">
                  <router-link :to="{
                    name: 'createScreen',
                    params: {
                      movie_id: singleMovie.movie_id,
                      content_lang_id: singleMovie.content_lang_id
                    }
                  }">
                    <div class="movieSlider-container mx-auto text-center">
                      <div class="img-container">
                        <router-link :to="{
                          name: 'createScreen',
                          params: {
                            movie_id: singleMovie.movie_id,
                            content_lang_id: singleMovie.content_lang_id
                          }
                        }">
                          <img alt v-lazy="singleMovie.md_thumbnail_url" class="img-fluid mx-auto banner" />
                        </router-link>
                      </div>
                      <div class="text-center mx-auto pt-2 pt-md-3 movieSliderInfo">
                        <p class="mb-0 title">{{ singleMovie.movie_title }}</p>
                        <ul class="list-inline mb-0 mInfo">
                          <li class="list-inline-item">
                            {{ singleMovie.mf_name }}
                          </li>
                          <li class="list-inline-item">|</li>
                          <li class="list-inline-item">
                            {{ singleMovie.rating }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </router-link>
                </div>
              </Slick>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div v-else-if="loadingMini == false" class="row">
      <div class="col-12 text-center" style="color:#8d99af">
        <h5>No Movie Found</h5>
      </div>
    </div>
    <div class="row d-md-none" v-if="loadingMini">
      <div class="col-12 text-center">
        <img src="@/assets/img/loadMore.gif" class="load-more" />
      </div>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import $ from "jquery";
import EventBus from "@/eventBus.js";

export default {
  name: "NowShowingSlider",

  components: {
    Slick
  },
  props: {},
  data() {
    return {
      showModal: [],
      movieSlider: {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      SubTitle: "Gog Library",
      Title: "",
      routeName: "",
      loadingMini: true,
      miniFestivals: []
    };
  },
  computed: {
    MiniFestivalsArray() {
      let specialItem = this.miniFestivals.filter(item => item.unique_id === 270365326);
    let otherItems = this.miniFestivals.filter(item => item.unique_id !== 270365326 && item.category_link_movie_id !== 2450);

    // Sort the other items alphabetically by category_link_name
    otherItems.sort((a, b) => {
      const nameA = a.category_link_name.toUpperCase(); // Ignore case
      const nameB = b.category_link_name.toUpperCase(); // Ignore case
      if (nameA === "NEW RELEASES MOVIES") return -1;
      if (nameB === "NEW RELEASES MOVIES") return 1;
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0; // Names are equal
    });

    // Combine the special item with the sorted array
    return [...specialItem, ...otherItems];
  }

    
  },
  mounted() {
    this.routeName = window.location.pathname;
    EventBus.$on("MINI", val => {
      this.miniFestivals = val;
      this.loadingMini = false;
    });
    EventBus.$on("LoadingMini", val => {
      this.loadingMini = val;
      this.miniFestivals = [];
    });
  },
  methods: {
    openModal(index) {
      this.$set(this.showModal, index, true);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/UpcomingMiniFestivalsMobile.vue